
import type {
  Value,
  Variant
} from "./types/product"

// 过滤掉不存在的values---color
const getFilterValuesColor = ({
  values,
  variants,
  attribute_code // lw_color
}:{
    values: Value[]
    variants: Variant[],
    attribute_code: string
}) => {
  const tempArray: Value[] = []


  values?.forEach((item) => {
    const find = variants.find((temp) => {
      return temp.attributes.some((attr) => attr.code === attribute_code &&
                        attr.value_index === item.value_index)
    })

    if (find) {
      tempArray.push(item)
    }
  })

  return tempArray
}

// 找到当前 color 的所有 variants
const findVariants = ({
  item_value_index,
  variants
}:{
    item_value_index: number
    variants: Variant[]
}) => {
  const match = variants.filter((variant) => {
    const {
      attributes 
    } = variant || {}
    const {
      value_index: variant_value_index 
    } = attributes[0] || {}

    return variant_value_index === item_value_index
  })

  return match
}

export const getSortedColor = ({
  values,
  variants,
  attribute_code
}:{
    values: Value[]
    variants: Variant[],
    attribute_code: string
}) => {

  const instockArray: Value[] = []
  const outofStockArray: Value[] = []

  const filterValuesColor = getFilterValuesColor({
    values,
    variants,
    attribute_code
  })

  filterValuesColor.forEach((item) => {
    const {
      value_index: item_value_index 
    } = item || {}
  
    const match = findVariants({
      item_value_index,
      variants
    })
  
    const allOutOfStock = match.every(item => item.product.stock_status === "OUT_OF_STOCK");
  
    if (allOutOfStock) {
      outofStockArray.push(item)
    } else {
      instockArray.push(item)
    }
  })

  return [...instockArray, ...outofStockArray]
}
